import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
// import util from 'util';
import constClass from '../../Constants/Constants';
import { useToasts } from 'react-toast-notifications';
import { useParams } from 'react-router';
import Select from 'react-select';

const TicketGroup = (props) => {
  const { user } = props;
  const { siteId, mallId } = useParams();
  const [ticketMaster, setTicketMaster] = useState(null);
  const [ticketGroupData, setTicketGroupData] = useState([]);
  const [ticket, setTicketValues] = useState([]);
  const [lockData, setLockData] = useState(false);
  const { addToast } = useToasts();

  const PAGE_SIZE = 5;

  const [values, setValues] = useState({
    ticket_group_id: null,
    ticket_group_name: '',
    max_usage_count: 0,
  });

  const [searchKeyword, setSearchKeyword] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  const refreshData = useCallback(async () => {
    const jwt = localStorage.getItem('jwt');
    const ticketGroup = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/ticketgroup/${siteId}/${mallId}`, {
      headers: {
        Authorization: `Bearer ${jwt}`,
      }
    })).data; 
    setTicketGroupData(ticketGroup);
    const ticket = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/ticket/${siteId}/${mallId}`, {
      headers: {
        Authorization: `Bearer ${jwt}`
      }
    })).data.map((val) => { return { value: val.ticket_id, label: val.ticket_name }; });;
    setTicketMaster(ticket);
  }, [siteId, mallId]);

  /* 編集ボタン押下 */
  const handleUpdateClick = (data) => {
    const temp = data;
    const ticketValues = data.m_ticket_group_ticket.map(a => ({ value: a.ticket_id, label: ticketMaster.find(x => x.value === a.ticket_id).label }));
    if (ticketValues.length > 0) {
      setTicketValues(ticketValues);
    }
    setValues(temp);
  }

  /* RESETボタン押下 */
  const handleResetClick = () => {
    setValues({
      ticket_group_id: null,
      ticket_group_name: '',
      max_usage_count: 0,
    });
    setTicketValues([]);
  }

  /* DB更新 */
  const handleRegistClick = async (data) => {
    const jwt = localStorage.getItem('jwt');
    if (!data.ticket_group_name) {
      window.alert('クーポングループ名を入力してください。');
      return;
    }
    if (data.max_usage_count === "") {
      data.max_usage_count = 0;
    }
    var params = data;
    params.ins_name = user.userId;
    params.upd_name = user.userId;
    params.site_id = siteId;
    params.mall_id = mallId;

    console.log(params);
    

    if (ticket.length > 0) {
      params.m_ticket = ticket.map(ticket => ({ site_id: siteId, ticket_id: ticket.value}));
    }

    let res;
    try {
      setLockData(true);
      if (params.ticket_group_id === null || params.ticket_group_id === "") {
        res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/ticketgroup/insert`, params, {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        });
      } else {
        res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/ticketgroup/update/`, params, {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        });
      }
    } catch (err) {
      console.log(err);
      if (err.response.data !== null) {
        addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      if (!res) {
      } else if (res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast('登録しました。', { appearance: 'success', autoDismiss: true });
        await refreshData();
      }
      setLockData(false);
      handleResetClick();
    }
  }
  /* DB削除 */
  const handleDeleteClick = async (data) => {
    const jwt = localStorage.getItem('jwt');

    if (!window.confirm(`クーポングループ[${data.ticket_group_id}:${data.ticket_group_name}]を削除します。よろしいですか？`)) {
      return;
    }
    const params = {
      site_id: siteId,
      ticket_group_id: data.ticket_group_id,
      upd_date: data.upd_date
    };
    let res;
    try {
      setLockData(true);
      res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/ticketgroup/delete/`, params, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        }
      });
    } catch (err) {
      if (err.response.data !== null) {
        addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      if (res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast('削除しました。', { appearance: 'success', autoDismiss: true });
        await refreshData();
      }
      setLockData(false);
      handleResetClick();
    }
  }

  const handleChangeTicket = (data) => {
    setTicketValues(data);
  }

  const renderUpdateButton = (data) => {
    return (
      <button
        className={`btn btn-primary mx-1`}
        onClick={() => handleUpdateClick(data)}>
        編集
      </button>
    )
  }

  const renderRegistButton = (data) => {
    return (
      <button type="button"
        disabled={lockData || data.ticket_group_name === ''}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleRegistClick(data)}>
        登録
      </button>
    )
  }

  const renderDeleteButton = (data) => {
    return (
      <button type="button"
        disabled={lockData || data.ticket_group_id === null}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleDeleteClick(data)}>
        削除
      </button>
    )
  }

  const renderResetButton = () => {
    return (
      <button type="button"
        disabled={false}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleResetClick()}>
        リセット
      </button>
    )
  }

  const handleChange = (e) => {
    const target = e.target;
    const value = target.type === "checkbox" ? (target.checked ? constClass.FLAG.ON : constClass.FLAG.OFF) : target.value;
    const name = target.name;
    setValues({ ...values, [name]: value });
  }

  useEffect(() => {
    refreshData();
  }, [refreshData]); //

  const renderInput = () => {
    return (
      <div className="mx-1">
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <span>クーポングループID</span>
          </div>
          <div className="col-2 text-center align-self-center">
            <input
              type="text"
              className="form-control"
              name="ticket_group_id"
              defaultValue={values.ticket_group_id}
              placeholder="新規"
              readOnly
            />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <span>クーポングループ名</span>
          </div>
          <div className="col-5 text-center align-self-center">
            <input
              type="text"
              className="form-control"
              name="ticket_group_name"
              value={values.ticket_group_name}
              onChange={handleChange}
              placeholder="クーポングループ名を入力してください"
            />
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="use_flg">所属クーポン</label>
          </div>
          <div className="col-10 text-center align-self-center">
            <Select options={ticketMaster} isMulti closeMenuOnSelect={false} value={ticket} onChange={handleChangeTicket} placeholder="所属するクーポンを選択してください" />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="max_usage_count">上限使用回数</label>
          </div>
          <div className="col-5 align-self-center">
            <input type="text" className="form-control" name="max_usage_count" value={values.max_usage_count} onChange={handleChange} placeholder="グループ内で使用可能な回数" />
          </div>
          <div className="col-5 text-left align-self-center">
            無制限に利用可能とする場合は「0」を入力してください
          </div>
        </div>
        <div className="row mb-2 pb-4">
          <div className="col-3 text-center">{renderRegistButton(values)}</div>
          <div className="col-3 text-center">{renderDeleteButton(values)}</div>
          <div className="col-3 text-center">{renderResetButton(values)}</div>
        </div>
      </div>
    );
  };

  const renderList = () => {
    const filteredData = ticketGroupData.filter(data =>
      !searchKeyword || data.ticket_group_name.includes(searchKeyword)
    );
    const totalPages = Math.ceil(filteredData.length / PAGE_SIZE);
    const pagedData = filteredData.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);

    return (
      <div className="row mb-3 p-0 mt-2">
        <div className="col-12 mb-2">
          <div className="row">
            <input
              type="text"
              className="col-4 form-control"
              placeholder="クーポングループ名で絞り込み"
              value={searchKeyword}
              onChange={e => { setSearchKeyword(e.target.value); setCurrentPage(1); }}
            />
          </div>
        </div>
        <div className="col-12 p-0">
          <div className="d-flex justify-content-between align-items-center mb-1">
            <span className="small text-muted">{filteredData.length}件中 {Math.min((currentPage - 1) * PAGE_SIZE + 1, filteredData.length)}〜{Math.min(currentPage * PAGE_SIZE, filteredData.length)}件表示</span>
            {totalPages > 1 && (
              <nav>
                <ul className="pagination pagination-sm mb-0">
                  <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(p => p - 1)}>‹</button>
                  </li>
                  {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                    <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                      <button className="page-link" onClick={() => setCurrentPage(page)}>{page}</button>
                    </li>
                  ))}
                  <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(p => p + 1)}>›</button>
                  </li>
                </ul>
              </nav>
            )}
          </div>
          <table className="table table-bordered table-striped">
            <thead className={`table-info`}>
              <tr>
                <td className="text-center align-middle">クーポングループID</td>
                <td className="text-center align-middle">クーポングループ名</td>
                <td className="text-center align-middle">上限使用回数</td>
                <td className="text-center align-middle">処理</td>
              </tr>
            </thead>
            <tbody>
              {pagedData.map((data) => (
                <tr key={data.ticket_group_id}>
                  {/* クーポングループID */}
                  <td className="text-center align-middle">
                    {data.ticket_group_id}
                  </td>
                  {/* クーポングループ名 */}
                  <td className="text-center align-middle">
                    {data.ticket_group_name}
                  </td>
                  {/* 上限使用回数 */}
                  <td className="text-center align-middle">
                    {data.max_usage_count ? data.max_usage_count : '無制限'}
                  </td>
                  {/* 処理 */}
                  <td className="text-center align-middle text-nowrap">
                    {renderUpdateButton(data)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  return (
    <div className="container">
      {ticketGroupData === null && <div className="row"><div className="col-12">読み込み中・・・</div></div>}
      {ticketGroupData !== null && (renderList())}
      {renderInput()}
    </div>
  )
}

export default TicketGroup;